import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import { GameClient } from "../gameClient";
import { Button, ExtraMarketButton } from "../styles/ButtonStyle";
import { InfoLevel } from "../types/uiTypes";
import { PlayerConstants, ShopConstants, UIConstants } from "../../../shared/constants";
import { Sound } from "../../../shared/sound";
import { CostMarker } from "./TierMarker";

declare var gameClient: GameClient;

interface RefreshButtonProps {
	setHovered: (amount: number) => void;
	sendInfo: (text: string) => void;
	enabled?: boolean;
}

export const RefreshButton = (props: RefreshButtonProps) => {
	const [refHover, setRefHover] = React.useState(false);

	const hovered = () => {
		props.setHovered(1);
		setRefHover(true);
		if (gameClient) {
			gameClient.playUISound(Sound.Menu);
			props.sendInfo(`Refresh: Pay ${PlayerConstants.RefreshShopCost} and get a new set of immune cells`);
		}
	}
	const clear = () => {
		props.setHovered(0);
		props.sendInfo('');
		setRefHover(false);
	}

	const refreshShop = () => {
		gameClient.playUISound(Sound.ButtonClick);
		gameClient.sendRefreshShop();
	}

	return (
		<ExtraMarketButton disabled={!props.enabled} tabIndex={-1} className="goo-button" onClick={refreshShop} position={"center"} onMouseEnter={hovered} onMouseLeave={clear}>
			<FontAwesomeIcon size="2x" icon={faRedoAlt} />
			{refHover && <div style={{
				position: "absolute",
				top: 0,
				left: "50%"
			}}>
				<CostMarker cost={PlayerConstants.RefreshShopCost} position="center"/>
			</div>}
		</ExtraMarketButton>
	)
}
